import {createStyles} from '@material-ui/core/styles';

const styles = () => createStyles({
  filters__switchGroup: {
    marginLeft: '10px',
  },
  switchAddGroup: {
    marginLeft: '20px',
  },
});

export default styles;
